// var $ = require("jquery");
window.scrollLoad = true;
window.page_num = 1;

function escapeJobText(value) {
    return $('<div>').text(value || '').html();
}

function renderJobCard(job) {
    const company = job["company"] || {};
    const logo = company["logo_url"]
        ? `<img src="https://www.jobs-regional.de${company["logo_url"]}" alt="Logo ${escapeJobText(company["name"])}">`
        : `<span class="icon-job-search job-result-card__logo-fallback" aria-hidden="true"></span>`;
    const location = job["location"]
        ? `<span class="job-result-card__location"><span class="icon-location-target" aria-hidden="true"></span>${escapeJobText(job["location"])}</span>`
        : '';
    const kindBadges = String(job["vacancy_multiple_kinds"] || '')
        .split(',')
        .map(value => value.trim())
        .filter(Boolean)
        .map(value => `<span class="job-result-card__chip">${escapeJobText(value)}</span>`)
        .join('');

    return `<a class="job-result-card" href="/stellenangebote/${encodeURIComponent(job["id"])}">
        <article class="job-result-card__inner">
            <div class="job-result-card__logo">${logo}</div>
            <div class="job-result-card__content">
                <h3 class="job-result-card__title">${escapeJobText(job["title"])}</h3>
                <p class="job-result-card__company">
                    <span class="job-result-card__company-name">${escapeJobText(company["name"])}</span>
                    ${location}
                </p>
                <div class="job-result-card__meta">
                    <span class="job-result-card__chip job-result-card__chip--date">
                        <span class="icon-calendar-download" aria-hidden="true"></span>
                        ${escapeJobText(job["getDateRange"])}
                    </span>
                    ${kindBadges}
                </div>
            </div>
            <span class="icon-arrow-right job-result-card__arrow" aria-hidden="true"></span>
        </article>
    </a>`;
}

$(document).on('turbo:load', async function() {
    window.scrollLoad = true;
    window.page_num = 1;
    $("#job-search-btn").click(function() {
        $(this).closest("form").submit();
    });
    $(window).scroll(async function() {
        if ($('#jobs-loaded-list').length == 1) {
            if (window.scrollLoad && (window.location.href.indexOf("stellenangebote") > -1) && $(window).scrollTop() >= $(document).height() - $(window).height() - 300) {
                $("#jobs-loaded-list").append(`<div id="list_loader" class="row mt-3"><div class="col-12 justify-content-center text-center"><div class="spinner-border text-primary text-center" role="status"></div></div></div>`);
                window.scrollLoad = false;
                window.page_num = window.page_num + 1;
                let suggestions = await getJobList(window.page_num);
                $.each(suggestions.data.vacancies, function(key, job) {
                    $("#jobs-loaded-list").append(renderJobCard(job));
                });
                if (suggestions.data.vacancies.length < 1) {
                    window.scrollLoad = false;
                    $("#jobs-loaded-list").append(`<p class="fs-small text-black-50 text-center mt-3">Alle Ergebnisse gesehen</p>`)
                } else {
                    window.scrollLoad = true;
                }
                $("#list_loader").remove();
            }

        }
    });
});
async function getJobList(page_count) {
    // const response = await fetch('/load-new-jobs?page=' + page_count + '&radius=' + getUrlParameter('radius') + '&wo=' + getUrlParameter('wo') + '&was=' + getUrlParameter('was'), {
    const response = await fetch('/load-new-jobs?page=' + page_count + '&radius=' + $('#job-radius').val() + '&wo=' + $('#jobs_wo').val() + '&was=' + $('#job_search_input').val()+ '&vacancy_kinds[]='+ $("#vacancy_kinds").val(), {
        method: 'get',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    }).then(res => res.clone().json())
    return response;
}

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return "";
};

$(document).on('turbo:load', async function () {
  $( "#job-radius" ).change(async function() {
    $("#turbo-job-list").empty();
    if ($('#turbo-job-list').length == 1) {
            $("#turbo-job-list").append(`<div id="list_loader" class="row mt-3"><div class="col-12 justify-content-center text-center"><div class="spinner-border text-primary text-center" role="status"></div></div></div>`);
            let suggestions = await getJobList(1);
            if (suggestions.data.vacancies.length < 1) {
                window.scrollLoad = false;
                $("#turbo-job-list").append(`<div class="row mt-5 text-center mb-5">
                    <div class="col-12">
                      <h5>
                      Schade, leider keine passenden Stelle dabei.
                      Erweitere den Umkreis Deiner Suche um mehr Suchergebnisse zu erhalten.
                      </h5>
                    <div class="icon-job-search mt-3 fs-150px"></div>
                    </div>
                  </div>`);
            } else {
              $.each(suggestions.data.vacancies, function(key, job) {
                  $("#turbo-job-list").append(renderJobCard(job));
              });
            }
            $("#turbo-job-list").append(`<div id="jobs-loaded-list"></div>`)
            $("#list_loader").remove();
            window.scrollLoad = true;
    }
  });


  let selectedSearchKinds = [];
  let selectedSearchKindsFilter = [];
  $( ".vacancy_kinds" ).each(function() {
      $(this).prop("checked") && selectedSearchKinds.push($(this).val());
      $(this).on("click", function(){
         selectedSearchKinds.includes($(this).val()) ? selectedSearchKinds.splice( selectedSearchKinds.indexOf($(this).val()), 1 ) : selectedSearchKinds.push($(this).val());
         $("#vacancy_kinds").val(selectedSearchKinds);
       });
  });
  $( ".vacancy_kinds_filter" ).each(function() {
      $(this).prop("checked") && selectedSearchKindsFilter.push($(this).val());
      $(this).on("click", function(){
         selectedSearchKindsFilter.includes($(this).val()) ? selectedSearchKindsFilter.splice( selectedSearchKindsFilter.indexOf($(this).val()), 1 ) : selectedSearchKindsFilter.push($(this).val());
         $("#vacancy_kinds_filter").val(selectedSearchKindsFilter);
       });
  });
  $("#vacancy_kinds").val(selectedSearchKinds);
  $("#vacancy_kinds_filter").val(selectedSearchKindsFilter);
  $("#job-search-btn").on("click", function(){
    $( ".vacancy_kinds" ).each(function() {
        $(this).prop('checked', false);
    });
   });
   $('#job-kat-model').on('hidden.bs.modal', function () {
    $(".selected-kinds-text").html(selectedSearchKinds.length + ` Ausgewählte`)
  });
  $(".jobs-filter-button").on("click", function(){
    $("#jobs-list-filter-modal").modal("hide");
   });
});
